import { Box, Skeleton, SxProps } from '@mui/material';
import React, { FC } from 'react';

export interface LabeledSectionSkeletonProps {
  labelWidth: number;
  sx?: SxProps;
  labelPlaceholderWidth?: number;
  children?: React.ReactNode;
}

export const LabeledSectionSkeleton: FC<LabeledSectionSkeletonProps> = (props) => {
  const { labelWidth, labelPlaceholderWidth, sx, children } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', margin: '20px 20px 0 20px', paddingLeft: '5px', ...sx }}>
      <Box
        sx={{
          color: 'black',
          fontSize: '14px',
          lineHeight: '160%',
          fontWeight: 600,
          borderBottom: 'solid 1px #E9EAEE',
          paddingBottom: '5px',
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex'
        }}
      >
        <Skeleton variant="text" sx={{ width: labelWidth, height: '18px' }} />
        {labelPlaceholderWidth && (
          <Skeleton
            variant="rectangular"
            sx={{ width: labelPlaceholderWidth + 'px', height: '20px', marginRight: '15px' }}
          />
        )}
      </Box>
      <Box sx={{ lineHeight: '140%', letterSpacing: '0.15px', fontSize: '12px', margin: '10px 5px 5px 5px' }}>
        {children}
      </Box>
    </Box>
  );
};
